import { mergeStyles, getTheme } from 'office-ui-fabric-react';
import { NeutralColors } from '@uifabric/fluent-theme';
import { ITextStyles } from "office-ui-fabric-react/lib/Text";
import { FontSizes } from "@uifabric/fluent-theme";

const theme = getTheme();

export const textContainerS = mergeStyles({
    display: "flex",
    flexDirection: "column",
    paddingTop: 10,
    paddingBottom: 10
})

export const titleS: ITextStyles = {
    root: {
        fontSize: FontSizes.size16,
        fontWeight: "600",
        marginBottom: 10,
    }
}

export const subTitleS: ITextStyles = {
    root: {
        fontSize: FontSizes.size16,
        color: NeutralColors.gray130
    }
}

// CUO specific styles
export const cuoSectionContainer = mergeStyles({
    marginTop: 20,
    padding: 15,
    border: '1px solid #ddd',
    borderRadius: 5,
    backgroundColor: '#f9f9f9'
})

export const cuoSectionTitle: ITextStyles = {
    root: {
        margin: '0 0 15px 0',
        color: theme.palette.themePrimary,
        fontSize: FontSizes.size18,
        fontWeight: "600"
    }
}

export const cuoSubsectionTitle: ITextStyles = {
    root: {
        margin: '0 0 10px 0',
        color: theme.palette.themePrimary,
        fontSize: FontSizes.size14,
        fontWeight: "600"
    }
}

export const cuoGridTwoColumns = mergeStyles({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '10px',
    marginBottom: 15
})

export const cuoGridThreeColumns = mergeStyles({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: '10px'
})

export const cuoGridFourColumns = mergeStyles({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridGap: '8px',
    marginBottom: 8
})

export const cuoSubsection = mergeStyles({
    marginBottom: 15
})

export const cuoCompactSection = mergeStyles({
    marginBottom: 8
})

export const cuoCompactContainer = mergeStyles({
    marginBottom: 15,
    padding: 8,
    border: '1px solid #ddd',
    borderRadius: 5,
    backgroundColor: '#f9f9f9',
    fontSize: FontSizes.size12
})

export const cuoCompactTitle = mergeStyles({
    fontSize: FontSizes.size10,
    fontWeight: "bold",
    color: theme.palette.themePrimary,
    marginBottom: 3
})

export const cuoCompactText = mergeStyles({
    fontSize: FontSizes.size10,
    marginBottom: 2
})

export const cuoCompactClientInfo = mergeStyles({
    fontSize: FontSizes.size10
})

export const cuoCompactClientLabel = mergeStyles({
    fontWeight: "bold",
    color: theme.palette.themePrimary
})

export const cuoFormContainer = mergeStyles({
    marginTop: 20,
    padding: 20,
    border: '1px solid #ccc',
    borderRadius: 4,
    backgroundColor: '#f9f9f9'
})

export const cuoFormTitle: ITextStyles = {
    root: {
        margin: '0 0 15px 0',
        fontSize: FontSizes.size16,
        fontWeight: "600"
    }
}

export const cuoFormSection = mergeStyles({
    marginTop: 20
})

export const cuoLoadingContainer = mergeStyles({
    textAlign: 'center',
    padding: 20
})
